<template>
  <v-row justify="space-between">
    <span class="title font-weight-medium m-3">
      {{ title }}
    </span>

    <v-flex xs12 md3 sm6>
      <v-col align="center">
        <v-btn
          block
          color="success"
          class="white--text"
          @click="buttonFunction"
        >
          {{ buttonText }}
        </v-btn>
      </v-col>
    </v-flex>
  </v-row>
</template>

<script>
export default {
  props: {
    title: String,
    buttonText: String,
    buttonFunction: Function,
  },
};
</script>
